// bulkSpareLotApiSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../apiSlice";

/* ---------- Adapter ---------- */
const bulkLotAdapter = createEntityAdapter({
  selectId: (lot) => lot.id,
});

const initialState = bulkLotAdapter.getInitialState();

/* ---------- API ---------- */
export const bulkSpareLotSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBulkSpareLot: builder.query({
      query: ({ seller_id }) =>
        `/bulk_deals/spares/lots?seller_id=${seller_id}`,

      transformResponse: (response) =>
        bulkLotAdapter.setAll(
          { ...initialState }, // ✅ fresh copy
          response?.data ?? []
        ),
    }),
  }),
});

export const { useGetBulkSpareLotQuery } = bulkSpareLotSlice;

/* ---------- Selector Factory ---------- */
export const makeSelectBulkSpareLotSelectors = (seller_id) => {
  const selectLotQueryResult =
    bulkSpareLotSlice.endpoints.getBulkSpareLot.select({ seller_id });

  const selectLotData = createSelector(
    [selectLotQueryResult],
    (result) => result?.data ?? initialState
  );

  return bulkLotAdapter.getSelectors((state) => selectLotData(state));
};